import { notificationPage } from '@environments/feature-environments/notification-page.environment';
import { dashboard } from './feature-environments/dashbord.environment';

/**
 * Configuration spécifique à l'application séparée par fonctionnalité.
 */
export const appEnvironment = {
  notificationPage,
  dashboard,
};